import T from "../../theme";
import { Icon } from "../ui/Icon";
import { Avatar } from "../ui/Avatar";

/* ═══════════════════════════════════════════════════════════════════════
   NavButton — shared navigation button used in all sidebars/drawers
   ═══════════════════════════════════════════════════════════════════════ */
export const NavButton = ({ item, active, onClick, badge, iconSize = 16, gap = 9, padding = "9px 11px", mb = 2, ellipsis = false, suffix = null, dimmed = false }) => (
  <button
    key={item.id}
    onClick={onClick}
    className={`nav-btn${active ? " active" : ""}`}
    style={{
      width: "100%", display: "flex", alignItems: "center", gap, padding,
      borderRadius: 8, background: active ? T.primary : "transparent",
      border: "none", color: active ? "#fff" : T.textMuted,
      cursor: "pointer", marginBottom: mb, fontSize: 14,
      fontWeight: active ? 600 : 400, transition: "all 0.15s", textAlign: "left",
      opacity: dimmed ? 0.5 : 1,
    }}
  >
    <Icon name={item.icon} size={iconSize} color={active ? "#fff" : T.textMuted} />
    {ellipsis ? (
      <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}>
        {item.label}
      </span>
    ) : item.label}
    {suffix && <span style={{ marginLeft: "auto" }}>{suffix}</span>}
    {!suffix && badge && (
      <span style={{
        marginLeft: "auto", background: T.danger, color: "#fff",
        borderRadius: "50%", width: 18, height: 18, fontSize: 12, fontWeight: 800,
        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
      }}>!</span>
    )}
  </button>
);

/* ═══════════════════════════════════════════════════════════════════════
   UserFooter — dark mode toggle + logout buttons (shared)
   ═══════════════════════════════════════════════════════════════════════ */
export const UserFooter = ({ dark, onToggleDark, onLogout, iconSize = 14, gap = 8, padding = "8px 10px" }) => (
  <>
    <button
      onClick={onToggleDark}
      className="nav-btn"
      style={{
        width: "100%", display: "flex", alignItems: "center", gap, padding,
        borderRadius: 8, background: "transparent", border: "none",
        color: T.textMuted, cursor: "pointer", fontSize: 13, fontWeight: 500,
        transition: "background 0.15s", marginBottom: 2,
      }}
    >
      <Icon name={dark ? "sun" : "moon"} size={iconSize} color={T.textMuted} />
      {dark ? "Modo Claro" : "Modo Escuro"}
    </button>
    <button
      onClick={onLogout}
      className="nav-btn"
      style={{
        width: "100%", display: "flex", alignItems: "center", gap, padding,
        borderRadius: 8, background: "transparent", border: "none",
        color: T.textMuted, cursor: "pointer", fontSize: 13, fontWeight: 500,
        transition: "background 0.15s",
      }}
    >
      <Icon name="logout" size={iconSize} color={T.textMuted} />
      Sair da Conta
    </button>
  </>
);

/* ═══════════════════════════════════════════════════════════════════════
   UserInfo — user name + email display block
   ═══════════════════════════════════════════════════════════════════════ */
export const UserInfo = ({ user, size = 34 }) => (
  <>
    <Avatar user={user} size={size} />
    <div style={{ flex: 1, minWidth: 0 }}>
      <p style={{ fontSize: 13, fontWeight: 600, color: T.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {user.name}
      </p>
      <p style={{ fontSize: 11, color: T.textMuted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {user.email}
      </p>
    </div>
  </>
);

/* ═══════════════════════════════════════════════════════════════════════
   SuperAdminBadge — "Gestor VillaGest" badge
   ═══════════════════════════════════════════════════════════════════════ */
export const SuperAdminBadge = () => (
  <div style={{ padding: "10px 14px", borderBottom: `1px solid ${T.border}` }}>
    <div style={{
      display: "flex", alignItems: "center", gap: 8,
      padding: "8px 10px", borderRadius: 8,
      background: T.warningLight, border: `1px solid ${T.warning}`,
    }}>
      <Icon name="shield" size={14} color={T.warning} />
      <span style={{ fontSize: 12, fontWeight: 600, color: T.warning }}>
        Gestor VillaGest
      </span>
    </div>
  </div>
);

/* ═══════════════════════════════════════════════════════════════════════
   Logo — shared logo header for sidebar
   ═══════════════════════════════════════════════════════════════════════ */
export { default as logoEscuro } from "../../assets/logo_escuro.svg";
export { default as logoBranco } from "../../assets/logo_branco.svg";
